import React, { useState } from 'react';
// @ts-ignore
import styles from './EReceptList.module.scss';
// @ts-ignore
import moment, { Moment } from 'moment';
import Text from '../../Base/Text/Text';
import { EReceptListLitemProps } from './EReceptListItem';
import { getMomentDate } from '../../../Utils/dates.util';
import { useAppContext } from '../../../Services/AppContext';
import useTranslation from '../../../Hooks/useTranslation';

export default function EReceptListItemDefault(props: EReceptListLitemProps) {
	const { item } = props;
	const { dateFormatMoment } = useAppContext();
	const { t } = useTranslation();

	return (
		<div className={styles.content}>
			<div className={styles.medicamentWrapper}>
				<div className={styles.medicament}>
					{!item.items.length && <>{item.code}</>}
					{item.items.length > 0 &&
						item.items.map((i, index) => {
							return (
								<React.Fragment key={index}>
									{i.extra?.medicine} <span>{i.extra?.concentration}</span>
									<br />
								</React.Fragment>
							);
						})}
				</div>
				<div className={styles.dose}>
					{item.items.length > 0 &&
						item.items.map((i, index) => {
							return (
								<React.Fragment key={index}>
									{i.extra?.amount} {t('component.eReceptList.units')}
									<br />
								</React.Fragment>
							);
						})}
				</div>
			</div>
			{!!item.validUntil && (
				<div className={styles.validity}>
					<Text
						tx={'component.ePrescription.expirationDate'}
						firstUpper={true}
						inline={true}
					/>{' '}
					{getMomentDate(item.validUntil).format(dateFormatMoment)}
				</div>
			)}
		</div>
	);
}
